export default "__VITE_ASSET__DazjgjSP__"